import { useEffect, useState } from "react";
import MobileLayout from "../MobileLayout";
import Logo from "../asset/logo/LOGO_ORANGE.svg";
import blueAlien from "../asset/characters/BlueAlien.png";
import introductionAlien from "../asset/characters/introductionAlien.png";
import { AppBar, Box, CircularProgress, makeStyles, Toolbar, Typography } from "@material-ui/core";
import { useNavigate, useLocation } from "react-router";
import breeferButton from "../asset/icons/breeferPlayButton.png";
import { authenticateBreefAccessLink, getBreefReport } from "../lib/token/authenticateService";
import { resetLearningStats } from "../lib/learningStats";
import { getBreefById } from "./BreefService";
import { useDispatch } from "react-redux";
import { BreefDetails, setBreefDetails } from "../game/slice";
import { setNewUser } from "../login/slice";
import { useTranslation } from "react-i18next";
import "../App.css";
import analytics from "../analytics/track";
import { ConsentStep } from "../privacy/ConsentStep";
import { ConsentState, getConsent } from "../privacy/consentService";

// import moment from 'moment-timezone';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    backgroundColor: "transparent",
    boxShadow: "none",
  },
}));
export const Introduction = () => {
  const classes = useStyles();
  const [t, i18n] = useTranslation("global");
  sessionStorage.setItem("pageReloaded", "false");
  const dispatch = useDispatch();
  const [userName, setUserName] = useState("");
  const [userDetail, setUserDetail] = useState<object>();
  const [breefDetail, setBreefDetail] = useState<BreefDetails>();
  const [prize, setPrize] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isTracked, setIsTracked] = useState(false);
  // The participant must accept the information about their data before playing (asked once per text version)
  const [consent, setConsent] = useState<ConsentState | null>(null);
  // With an invite link: show nothing until we know whether the participant has accepted (no flash of the intro)
  const [checkingConsent, setCheckingConsent] = useState(() => Boolean(new URLSearchParams(window.location.search).get("token")));

  let breefReport: any;
  let authResponse: any;
  let userId: string;

  useEffect(() => {
    const authenticate = async () => {
      sessionStorage.clear();
      const token = new URLSearchParams(location?.search).get("token");
      if (token) {
        try {
          authResponse = await authenticateBreefAccessLink(token);
          // A new breef: start the learning data (video, questions) afresh
          resetLearningStats();
          const breefId = authResponse?.breefDetails.breefId;
          userId = authResponse.userDetails?._id;
          const userDetails = authResponse.userDetails;
          // const dateParts = dateString.split("/");
          // const formattedDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
          // formattedDate.setHours(0, 0, 0, 0);
          // const date = new Date()

          sessionStorage.setItem("firstName", userDetails.firstName);
          sessionStorage.setItem("lastName", userDetails.lastName);
          sessionStorage.setItem("email", userDetails.email);
          sessionStorage.setItem("phone", userDetails.phoneNumber);
          sessionStorage.setItem("tenantId", userDetails.tenantId);
          sessionStorage.setItem("BreefAccesstoken", token);
          sessionStorage.setItem("teamId", userDetails.teamIds);
          setUserDetail(userDetails);
          
          const breefDet = authResponse.breefDetails;
          sessionStorage.setItem("breefId", breefDet.breefId);
          sessionStorage.setItem("videoUrl", breefDet.videoUrl);
          setPrize(breefDet.prize);
         

          const breefDetails = await getBreefById(breefId);
          setBreefDetail(breefDetails);
          dispatch(setBreefDetails(breefDetails));
          analytics.track("Inroduction Page Viewed", {
            breef_id: breefDetails.breefId,
            tenant_id: userDetails.tenantId,
            user_id: userId,
            number_of_qustions: breefDetails.questions.length,
            start_date: breefDetails.period,
            expiry_date: breefDetails.expiry,
            video_url: breefDetails.videoUrl,
            current_page: "intro",
            game_name: breefDetails.gameName,
          });
          console.log(userDetails._id);
          if (userDetails._id) {
            sessionStorage.setItem("InvitedUserId", userDetails._id);
          }
          setUserName(userDetails.firstName);
          setConsent(await getConsent().catch(() => ({ version: "", answer: null })));
          setCheckingConsent(false);
        } catch (error: any) {
          setCheckingConsent(false);
          // No toast here: every case below lands on a page that says what is going on (the game, the result or
          // /no-access with the reason). A red "expired" banner on top of the result page was wrong more often than right.
          console.error("Failed to authenticate token:", error);
          if (error?.response?.status === 401 && error?.response?.data?.userDetails) {
            const userDetails = error.response.data.userDetails;

            sessionStorage.setItem("userId", userDetails._id);
            sessionStorage.setItem("firstName", userDetails.firstName);
            sessionStorage.setItem("lastName", userDetails.lastName);
            sessionStorage.setItem("email", userDetails.email);
            sessionStorage.setItem("phone", userDetails.phoneNumber);
            sessionStorage.setItem("tenantId", userDetails.tenantId);
            sessionStorage.setItem("BreefAccesstoken", token);
            sessionStorage.setItem("teamId", userDetails.teamIds);
            sessionStorage.setItem("InvitedUserId", userDetails._id);
            setUserDetail(userDetails);
            
            const breefDet = error?.response?.data?.breefDetails;
            sessionStorage.setItem("breefId", breefDet.breefId);
            sessionStorage.setItem("videoUrl", breefDet.videoUrl);
            setPrize(breefDet.prize);
          }
          // Where to, depends on why the server said no:
          //   already_played + game missing + breef open -> straight to the game (the quiz is kept)
          //   already_played                            -> the result for this breef, then the level
          //   breef_closed (never played)               -> "the breef is closed"
          //   not_open_yet                              -> "opens on ..."
          //   no details (link expired or forged)       -> "the link has expired"
          //   no answer / 5xx / 429                     -> "could not connect, try again"
          if (authResponse?.message !== "Authenticated") {
            const status = error?.response?.status;
            const data = error?.response?.data || {};
            if (status === 401 && data.userDetails) {
              if (data.reason === "already_played" && data.played && !data.played.game && data.state === "open") navigate("/game");
              else if (data.reason === "already_played") navigate("/breef-score");
              else if (data.reason === "not_open_yet") navigate(`/no-access?reason=upcoming&date=${encodeURIComponent(data.breefDetails?.period || "")}`);
              else navigate("/no-access?reason=closed");
            } else if (status === 401 || status === 404 || status === 400) {
              navigate("/no-access?reason=expired");
            } else {
              navigate("/no-access?reason=error");
            }
          }
          setError(t("messages.authFailed"));
        }
      } else {
        const breef = (location.state as any)?.breef;
        if (breef) {
          console.log("Breef from state:", breef);
          dispatch(setBreefDetails(breef));
          setUserName(sessionStorage.getItem("firstName") || "Guest");
          setPrize(breef.prize);
        } else {
          // No token and nothing in the history: the link is the only way in
          navigate("/no-access");
        }
      }
    };

    authenticate();
  }, [location]);
  const nextButtonHandle = async () => {
    // Not known yet (still loading, or opened without the token in the URL): ask the server first
    const current = consent ?? (await getConsent().catch(() => ({ version: "", answer: null } as ConsentState)));
    if (current.answer !== "accepted") {
      setConsent(current);
      return;
    }
    navigate("/video");
  };

  // The first thing after the SMS: the logo while the link is being checked, rather than a blank screen
  if (checkingConsent)
    return (
      <MobileLayout>
        <div style={{ height: "100dvh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "1.5rem" }}>
          <img src={Logo} alt="Breefer" style={{ width: 150 }} />
          <CircularProgress style={{ color: "#EB6608" }} size={28} />
        </div>
      </MobileLayout>
    );

  if (consent && consent.answer !== "accepted") {
    return <ConsentStep version={consent.version} insight={consent.insight} onAccepted={() => setConsent({ ...consent, answer: "accepted" })} />;
  }

  return (
    <MobileLayout>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          margin: "16%",
        }}
      >
        <AppBar position="static" className={classes.appBar}>
          <Toolbar>{/* <img src={Logo} alt="logo" height="80 rem" /> */}</Toolbar>
        </AppBar>
        <div className="container">
          <div className="container">
            {t("introduction.hi")} {userName}.<div>{t("introduction.title1")} </div>
            <span
              onClick={() => {
                nextButtonHandle();
                analytics.track("Click here button clicked", {
                  breef_id: breefDetail?.id,
                  tenant_id: breefDetail?.tenantId.id,
                  user_id: userId,
                  number_of_qustions: breefDetail?.questions.length,
                  start_date: breefDetail?.period,
                  expiry_date: breefDetail?.expiry,
                  video_url: breefDetail?.videoUrl,
                  current_page: "intro",
                  game_name: breefDetail?.gameId.gameName,
                });
              }}
              style={{ color: "#EB6608", cursor: "pointer", fontWeight: "bold" }}
            >
              {t("introduction.spanTxt")}{" "}
            </span>
            {t("introduction.title2")} {prize}.
          </div>
        </div>
      </div>

      <Box
        style={{
          position: "absolute",
          bottom: "7rem",
          left: "50%",
          transform: "translateX(-50%)",
          height: "100%",
        }}
      >
        {/* <img src={breeferButton} alt="Breefer Button" onClick={nextButtonHandle} style={{ cursor: 'pointer' }} /> */}
        <img
          src={introductionAlien}
          onClick={nextButtonHandle}
          alt="Videre"
          style={{ position: "absolute", top: "90%", right: -150, width: "150px", height: "150px" }}
        />
      </Box>
    </MobileLayout>
  );
};
